import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ErrorPage from "./pages/ErrorPage";
import LoginPage from "./pages/LoginPages/Login";
import Investments from "./pages/ChildPages/Investments";
import Savings from "./pages/ChildPages/Savings";
import Lessons from "./pages/ChildPages/Lessons";
import Jobs from "./pages/ChildPages/Jobs";
import CreateAccount from "./pages/LoginPages/CreateAccount";
import AddChild from "./pages/LoginPages/AddChild";
import ForgotPassword from "./pages/LoginPages/ForgotPassword";
import ParentDash from "./pages/ParentPages/ParentDash";
import LandingPage from "./pages/LandingPage";
import LessonVideo from "./pages/ChildPages/LessonVideo";
import { AuthProvider } from "./services/AuthContext";
import SelectChildPage from "./pages/ChildPages/SelectChild";
import ProtectedRoute from "./services/ProtectedRoute";
import { ToastProvider } from "./services/ToastContext";
import { RefreshProvider } from './services/RefreshContext';
import ResetPasswordPage from './pages/LoginPages/ResetPassword';


function App() {

  return (
    <div className="App">
      <div id="wrapper">
        <BrowserRouter>
          <AuthProvider>
            <ToastProvider>
              <RefreshProvider>
                {/* <Sider /> */}
                <div id="content-wrapper" className="d-flex flex-column">
                  <div id="content" className="bodyBackgroundColor">
                    <Header />
                    <Routes>
                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/" element={<Home />} />
                      <Route path="/create-account" element={<CreateAccount />} />
                      <Route path="/add-child" element={<AddChild />} />
                      <Route path="/forgot-password" element={<ForgotPassword />} />
                      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

                      {/* Protect Routes that need authentication */}
                      <Route element={<ProtectedRoute />}>
                        <Route path="/investments" element={<Investments />} />
                        <Route path="/savings" element={<Savings />} />
                        <Route path="/lessons" element={<Lessons />} />
                        <Route path="/jobs" element={<Jobs />} />
                        <Route path="/grownups" element={<ParentDash />} />
                        <Route path="/landingpage" element={<LandingPage />} />
                        <Route path="/lessons/video/:videoId" element={<LessonVideo />} />
                        <Route path="/selectchild" element={<SelectChildPage />} />
                      </Route>                      

                      <Route path="*" element={<ErrorPage />} />

                    </Routes>
                  </div>
                  <Footer />
                </div>
              </RefreshProvider>
            </ToastProvider>
          </AuthProvider>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
